import { SelectedItemState } from 'app/features/selectedItem/slice/types';
import {
  Attribute,
  Brackets,
  Couplings,
  Inserts,
  MountingPart,
  MountingPlate,
  SingleItemData,
} from '../../configuratorData/slice/types';
import { getAttributeValue } from 'app/features/configuratorData/slice/utils';
import {
  mountingPositionMap,
  sapProductionText,
} from 'app/pages/ServicePage/utils';

// export type ActuatorType = 'pneumatic_actuator' | 'electric_actuator';

export const getSapConfDesc = (
  valveAttr: Attribute[],
  actuatorAttr: Attribute[],
  actuatorType: any,
  erpSystem: string,
) => {
  const valveType = getAttributeData(valveAttr, 'EGTF_1111__STRING'); // Type
  const valveSize = getAttributeData(valveAttr, 'EF023191__STRING'); // Nominal Inner Diameter
  const valvePressure = getAttributeData(valveAttr, 'EF020007__STRING'); // Pressure rating
  let actuatorModel = '';
  if (actuatorType !== 'gearbox') {
    actuatorModel = getAttributeData(actuatorAttr, 'EF024309__STRING'); // Model
  } else {
    actuatorModel = getAttributeData(actuatorAttr, 'EGTF_3828__STRING');
  }
  let concValveSize = valveSize;
  if (valveSize.includes('"')) {
    concValveSize = valveSize.substring(0, valveSize.indexOf('"') + 1);
  }

  let actuatorVoltage = '';
  if (actuatorType === 'electric_actuator') {
    actuatorVoltage = ' ' + getAttributeData(actuatorAttr, 'EF020233__STRING');
  }
  const actuatorString = actuatorModel + actuatorVoltage;

  const confDesc =
    (erpSystem === 'FR' ? 'MONT. ' : 'Assy. ') +
    valveType +
    ' ' +
    concValveSize +
    ' ' +
    valvePressure +
    ' ' +
    actuatorString;

  if (confDesc.length > 40) {
    return confDesc.substring(0, 40);
  }
  return confDesc;
};

export const getAttributeData = (
  attributesList: Array<Attribute>,
  attrIdentifier: string,
) => {
  const filteredAttribute = attributesList.find(
    attr => attr.attributeIdentifier === attrIdentifier,
  );
  const value = getAttributeValue(filteredAttribute);
  return value ? value : '';
};

export const getChosenItemConf = (
  allChosenItems: SelectedItemState,
  inserts: Array<Inserts>,
  mountingPart: Array<MountingPart>,
  isMountingApply: boolean,
  selectedStemExtensions: any,
  selectedPucks: any,
  selectedSpeedControlBlock: any,
  selectedMountingPlate: Array<MountingPlate>,
  selectedCoupling: Couplings,
  selectedBracket: Brackets,
) => {
  let selItems: Array<SingleItemData | Inserts | any> = [];
  let monitoringItem = null;
  //taking only selected item from saved data. Also removing null value from skipped steps
  Object.keys(allChosenItems).forEach(stepNum => {
    monitoringItem = allChosenItems[3].item;
    if (
      allChosenItems[stepNum].item !== null &&
      !Array.isArray(allChosenItems[stepNum].item) &&
      stepNum !== '5'
    ) {
      selItems = [...selItems, allChosenItems[stepNum].item];
    }
  });
  //Adding inserts data details
  if (isMountingApply && monitoringItem !== null) {
    selItems = [...selItems, ...inserts, ...mountingPart];
    if (selectedMountingPlate[0] !== null) {
      selItems = [...selItems, ...selectedMountingPlate];
    }
  } else {
    selItems = [...selItems, ...inserts];
  }
  if (selectedStemExtensions.items.length !== 0) {
    selItems = [...selItems, ...selectedStemExtensions.items];
  }
  if (selectedPucks !== null) {
    selItems = [...selItems, ...selectedPucks];
  }
  if (selectedSpeedControlBlock.items.length !== 0) {
    selItems = [...selItems, ...selectedSpeedControlBlock.items];
  }
  if (selectedCoupling !== null) {
    selItems = [...selItems, selectedCoupling];
  }
  if (selectedBracket !== null) {
    selItems = [...selItems, selectedBracket];
  }
  const itemConfig = selItems.map(item => {
    return {
      partNumber: item.partNumber ? item.partNumber : item.id,
      brand: item.brand,
      configurationId: item.configuration,
      erpPartNumber: item.erpPartNumber,
      unitMeasure: item.quantityMeasure,
    };
  });
  return itemConfig;
};

export const getProductionText = (selectedService: string) => {
  let productionText =
    sapProductionText.info +
    '\n' +
    sapProductionText.mountingPosition +
    mountingPositionMap[selectedService];
  productionText = productionText.replace(/\n/g, '[SLASH]');
  productionText = '[SLASH]' + productionText;
  return productionText;
};
